import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import _ from 'lodash';
import Select from './editor/di-editor-select';
import uuidv4 from 'uuid/v1';
import convert from "xml-js";
import { Greeting } from '../../AuthenticatedApp';

// Import Components
import {
  di1EditorGetViewerList,
  di1EditorGetQuizList,
  di1EditorSetNewViewer,
  di1EditorSetViewerList,
  di1EditorSetNewQuiz,
  di1EditorSetQuizList,
  cloneCombinedStore,
  copyStore
} from '../../actions/editor-api-actions'
import { setModal } from '../../actions';

// Set variables
let buttonStatus = '';


// Main Class
class SelectEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedViewerGUID: null,
      selectedViewer: '',
      selectedQuizGUID: null,
      selectedQuiz: '',
      viewerDeleteBtn: {
        warning: false,
        title: "Delete Viewer",
        className: "btn-danger"
      },
      quizDeleteBtn: {
        warning: false,
        title: "Delete Quiz",
        className: "btn-danger"
      }
    };
  }

  componentDidMount() {
    // console.log("componentDidMount GUIDs: ", this.props.viewerGUID, this.props.quizGUID)
    if(this.props.viewerGUID) {
      this.props.di1EditorGetViewerList(this.props.viewerGUID, () => {
        // console.log("componentDidMount di1GetViewerList")
      })
      this.props.di1EditorGetQuizList(this.props.quizGUID, () => {
        // console.log("componentDidMount di1GetQuizList")
      })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(!this.props.existingViewers && this.props.viewerGUID) {
      this.props.di1EditorGetViewerList(this.props.viewerGUID, () => {})
    }
    if(!this.props.existingQuizzes && this.props.quizGUID) {
      this.props.di1EditorGetQuizList(this.props.quizGUID, () => {})
    }
  }

  onLogout() {
    // console.log("OnLogout Clicked", this.props);
    this.props.logout()
  }

  handleViewerSelectChange = (selected) => {
    // console.log("handleViewerSelectChange", selected)
    this.setState({
      selectedViewer: selected
    })
  }

  handleQuizSelectChange = (selected) => {
    // console.log("handleQuizSelectChange", selected)
    this.setState({
      selectedQuiz: selected
    })
  }

  editCurrentViewerHandler() {
    let redirectionURL = `/editor/${this.state.selectedViewer.value}/0/0/1`
    this.props.history.push(redirectionURL);
  }
  editCurrentQuizHandler() {
    let redirectionURL = `/editor/${this.state.selectedQuiz.value}/0/0/1`
    this.props.history.push(redirectionURL);
  }

  deleteCurrentViewerHandler() {
    if(!this.state.viewerDeleteBtn.warning) {
      this.setState({
        viewerDeleteBtn: {
          warning: true,
          title: "Really Delete?",
          className: "btn-outline-danger"
        }
      })
    } else {
      this.setState({
        selectedViewer: null,
        viewerDeleteBtn: {
          warning: false,
          title: "Delete Viewer",
          className: "btn-danger"
        }
      })
      this.deleteSelectedViewer()
    }
  }

  deleteCurrentQuizHandler() {
    if(!this.state.quizDeleteBtn.warning) {
      this.setState({
        quizDeleteBtn: {
          warning: true,
          title: "Really Delete?",
          className: "btn-outline-danger"
        }
      })
    } else {
      this.setState({
        selectedQuiz: null,
        quizDeleteBtn: {
          warning: false,
          title: "Delete Quiz",
          className: "btn-danger"
        }
      })
      this.deleteSelectedQuiz()
    }
  }

  createNewViewerHandler() {
  // POST - Create new viewer, generate GUID

  // VARS
  const newGUID = uuidv4().toUpperCase();
  let authData = {...this.props.authData }

  // VARS - NEW VIEWER
  const newViewer = `<div_data guid='${newGUID}' name='New HTML Image Set' quiz='0' imagesbaseurl="${authData.imagesBaseURL}" title1="Anatomy" title2="Plane/Pulse" title3="Image"><anatomy menuname="Anatomy Title"><plane_pulse menuname="Plane/Pulse Title" /></anatomy></div_data>`
  //const newViewer = `<div_data guid="${newGUID}" name="TEST VIEWER" quiz="0" imagesbaseurl="${authData.imagesBaseURL}" title1="Anatomy" title2="Plane/Pulse" title3="Image"> <anatomy menuname="Cervical Spine &amp; Neck"> <plane_pulse menuname="Axial T2 Weighted" scout="images/Scout_1.jpg" orient="1"> <image path="images/test_2.jpg"> <term text="CSF in Spinal Canal"> <line x="252" y="242" /> </term> </image> <image path="images/test_3.jpg" pos="46"> <term text="Body of Vertebrae"> <line x="235" y="209" /> </term> </image> <image path="images/test_4.jpg" pos="46"> <term text="CSF in Spinal Canal"> <line x="264" y="246" /> </term> </image> <image path="images/test_5.jpg" pos="46"> <term text="ALL - Runs the length of the spine"> <line x="239" y="183" /> </term> </image> <image path="images/test_6.jpg" pos="46"> <term text="Articular Process"> <line x="295" y="241" /> </term> <term text="Vertebral Artery in Transverse Foramen"> <line x="185" y="208" color="NaN" /> <line x="289" y="214" color="16750848" /> </term> </image> </plane_pulse> <plane_pulse menuname="Coronal T1 Weighted" scout="images/Scout_2.jpg" orient="1"> <image path="images/test_1.jpg" pos="21" /> </plane_pulse> <plane_pulse menuname="Sagittal T2 Weighted" scout="images/Scout3.jpg" orient="0"> <image path="images/test_7.jpg" pos="101"> <term text="Aorta"> <line x="252" y="208" /> </term> </image> </plane_pulse> </anatomy> <anatomy menuname="Sacrum &amp; Coccyx"> <plane_pulse menuname="Axial T1 Weighted" scout="images/Scout_3.jpg" orient="1"> <image path="images/test_8.jpg" pos="53"> <term text="Facet Joint"> <line x="193" y="264" /> </term> </image> </plane_pulse> <plane_pulse menuname="Coronal T1 Weighted" scout="images/Scout_4.jpg" orient="1"> <image path="images/test_9.jpg"> <term text="Fat"> <line x="67" y="375" /> </term> <term text="Ilium"> <line x="135" y="237" /> </term> <term text="Psoas Muscle"> <line x="344" y="84" /> </term> <term text="Spinous Process of Sacrum"> <line x="246" y="283" /> </term> </image> </plane_pulse> </anatomy> <instructions /> <instructor_email /> <quiz_title /> <log_id /> <objective_number /> </div_data>`
  let viewerData = {
    sUserName: authData.docstoreUsername,
    sSetPassword: authData.viewersDocStoreSetPassword,
    sDocIdentity: newGUID,
    sGetPassword: authData.viewersDocStoreGetPassword,
    sCreationPassword: authData.docstorePass,
    binString: newViewer
  }
  // VARS - NEW VIEWER LIST
  let viewerList = ''
  const newViewerEntry = `<viewer name="New HTML Image Set" guid="${newGUID}" />`

  _.map(this.props.existingViewers, viewer => {
    const viewerName = _.escape(viewer.name)
    const viewerEntry = `<viewer name="${viewerName}" guid="${viewer.guid}" />`
    viewerList += viewerEntry
  })
  viewerList += newViewerEntry;

  let viewerListXML = `<viewers>${viewerList}</viewers>`;
  let viewerListData = {
    sSetPassword: authData.viewersDocStoreSetPassword,
    sDocIdentity: authData.viewersDocStoreGUID,
    sBinString: viewerListXML
  }

  // DO STUFF
  let createNewViewer = new Promise((resolve, reject) => {
    // console.log("createNewViewerHandler Create new viewer")
    resolve(
      di1EditorSetNewViewer(viewerData, (res) => {
        // console.log("createNewViewerHandler callback:", res)
      })
    )
  })

  let createNewViewerList = new Promise((resolve, reject) => {
    // console.log('createNewViewerHandler - Set new viewerList')
    resolve(
      di1EditorSetViewerList(viewerListData, (res) => {
        // console.log("di1EditorSetViewerList callback:", res)
      })
    )
  })

  createNewViewer.then(
    createNewViewerList.then(
      this.props.di1EditorGetViewerList(this.props.viewerGUID, () => {
        // console.log('di1GetViewerList - Got the list back')
      })
    )
  )
  this.setState({
    selectedViewer: {label: "New HTML Image Set", value: newGUID }
  })
  let redirectionURL = `/editor/${newGUID}/0/0/1`
  this.props.history.push(redirectionURL);
}

createNewQuizHandler() {
  // POST - Create new viewer, generate GUID

  // VARS
  const newGUID = uuidv4().toUpperCase();
  let authData = {...this.props.authData }

  // VARS - NEW VIEWER
  const newQuiz = `<div_data guid='${newGUID}' name='New HTML Quiz' quiz='1' duration='30' imagesbaseurl="${authData.imagesBaseURL}" title1="Anatomy" title2="Plane/Pulse" title3="Image"><anatomy menuname="Anatomy Title"><plane_pulse menuname="Plane/Pulse Title"/></anatomy><instructions>&lt;p&gt;&lt;/p&gt;</instructions></div_data>`
  let quizData = {
    sUserName: authData.docstoreUsername,
    sSetPassword: authData.viewersDocStoreSetPassword,
    sDocIdentity: newGUID,
    sGetPassword: authData.viewersDocStoreGetPassword,
    sCreationPassword: authData.docstorePass,
    binString: newQuiz
  }
  // VARS - NEW VIEWER LIST
  let quizList = ''
  const newQuizEntry = `<viewer name="New HTML Quiz" guid="${newGUID}" />`

  _.map(this.props.existingQuizzes, quiz => {
    const quizName = _.escape(quiz.name)
    const quizEntry = `<viewer name="${quizName}" guid="${quiz.guid}" />`
    quizList += quizEntry
  })
  quizList += newQuizEntry;

  let quizListXML = `<viewers>${quizList}</viewers>`;
  let quizListData = {
    sSetPassword: authData.viewersDocStoreSetPassword,
    sDocIdentity: authData.quizzesDocStoreGUID,
    sBinString: quizListXML
  }

  // DO STUFF
  let createNewQuiz = new Promise((resolve, reject) => {
    // console.log("createNewQuizHandler Create new quiz")
    resolve(
      di1EditorSetNewQuiz(quizData, (res) => {
        // console.log("createNewQuizHandler callback:", res)
      })
    )
  })

  let createNewQuizList = new Promise((resolve, reject) => {
    // console.log('createNewQuizHandler - Set new quizList')
    resolve(
      di1EditorSetQuizList(quizListData, (res) => {
        // console.log("di1EditorSetQuizList callback:", res)
      })
    )
  })

  createNewQuiz.then(
    createNewQuizList.then(
      this.props.di1EditorGetQuizList(this.props.quizGUID, (res) => {
        // console.log('di1GetQuizList - Got the list back', res)
      })
    )
  )
  this.props.di1EditorGetQuizList(this.props.quizGUID, (res) => {
    // console.log('di1GetQuizList - Got the list back', res)
  })
  this.setState({
    selectedQuiz: {label: "New HTML Quiz", value: newGUID }
  })
  let redirectionURL = `/editor/${newGUID}/0/0/1`
  this.props.history.push(redirectionURL);
}

copyStore(copyItem, viewId, type) {
  copyStore(copyItem.value, viewId, type, (response) => {
    const ret = response.data.split("^^;;^^");
    if (type === "Quiz") {
      this.props.di1EditorGetQuizList(this.props.quizGUID, () => {
        this.setState({selectedQuiz: {value: ret[0], label: ret[1]}});
      });
    }
    else if (type === "Viewer") {
      this.props.di1EditorGetViewerList(this.props.viewerGUID, () => {
        this.setState({selectedViewer: {value: ret[0], label: ret[1]}});
      });
    }
  });
}

cloneCombinedStore(selectedIds, viewId, type) {
  cloneCombinedStore(selectedIds, viewId, type, (response) => {
    const ret = response.data.split("^^;;^^");
    if (type === "Quiz") {
      this.props.di1EditorGetQuizList(this.props.quizGUID, () => {
        this.setState({selectedQuiz: {value: ret[0], label: ret[1]}});
      });
    }
    else if (type === "Viewer") {
      this.props.di1EditorGetViewerList(this.props.viewerGUID, () => {
        this.setState({selectedViewer: {value: ret[0], label: ret[1]}});
      });
    }
  });
}

  // Delete Selected viewer
  deleteSelectedViewer() {
    let currentViewerList = this.props.existingViewers;
    let authData = {...this.props.authData }
    // eslint-disable-next-line
    let removedItem = _.remove(currentViewerList, {guid: this.state.selectedViewer.value})
    // console.log(currentViewerList, this.state.selectedViewer.value)

    let viewerList = ''

    _.map(currentViewerList, viewer => {
      const viewerName = _.escape(viewer.name)
      const viewerEntry = `<viewer name="${viewerName}" guid="${viewer.guid}" />`
      viewerList += viewerEntry
    })

    let viewerListXML = `<viewers>${viewerList}</viewers>`;
    let viewerListData = {
      sSetPassword: authData.viewersDocStoreSetPassword,
      sDocIdentity: authData.viewersDocStoreGUID,
      sBinString: viewerListXML
    }
    di1EditorSetViewerList(viewerListData, (res) => {
      // console.log("di1EditorSetViewerList callback:", res)
      this.props.di1EditorGetViewerList(this.props.viewerGUID, () => {
        // console.log('di1GetViewerList - Got the list back')
      })
    })
    this.props.di1EditorGetViewerList(this.props.viewerGUID, () => {
      // console.log('di1GetViewerList - Got the list back')
    })
  }

  deleteSelectedQuiz() {
    let currentQuizList = this.props.existingQuizzes;
    let authData = {...this.props.authData }
    // eslint-disable-next-line
    let removedItem = _.remove(currentQuizList, {guid: this.state.selectedQuiz.value})
    // console.log(currentQuizList, this.state.selectedQuiz.value)

    let quizList = ''

    _.map(currentQuizList, viewer => {
      const viewerName = _.escape(viewer.name)
      const viewerEntry = `<viewer name="${viewerName}" guid="${viewer.guid}" />`
      quizList += viewerEntry
    })

    let quizListXML = `<viewers>${quizList}</viewers>`;
    let quizListData = {
      sSetPassword: authData.viewersDocStoreSetPassword,
      sDocIdentity: authData.quizzesDocStoreGUID,
      sBinString: quizListXML
    }
    di1EditorSetQuizList(quizListData, (res) => {
      // console.log("di1EditorSetViewerList callback:", res)
      this.props.di1EditorGetQuizList(this.props.quizGUID, () => {
        // console.log('di1GetViewerList - Got the list back')
      })
    })
    this.props.di1EditorGetQuizList(this.props.quizGUID, () => {
      // console.log('di1GetViewerList - Got the list back')
    })
  }

  //////////////////////////////////////////////////////////////////////////////
  render() {
    // console.log("Render select-editor ----------------------------------------");
    return (
      <div className="select-editor">
      <div className="card">
        <div className="card-block">
          <Greeting />
          <h5 className="card-title text-primary"><p><strong>{this.props.program}</strong></p>Create or edit a viewer or quiz</h5>
          <p className="card-text">Please select the editor you would like to edit, or click 'create new viewer' or 'create new quiz'
          </p>
        </div>
        <form name="viewerInput">
          <ul className="list-group list-group-flush">
            <li className="list-group-item card-header">
              <h6 className="card-subtitle mb-2 text-muted">Viewers</h6>
              <Select
                value = {this.state.selectedViewer}
                existingViewers = {this.props.existingViewers}
                onChange={this.handleViewerSelectChange.bind(this)}
                className="current-viewers"
              />
              <button disabled={!this.state.selectedViewer} type="button" className={`btn btn-primary ${buttonStatus}`} onClick={this.editCurrentViewerHandler.bind(this)}>Edit Viewer</button>
              <button disabled={!this.state.selectedViewer} type="button" className={`btn btn-primary ${this.state.viewerDeleteBtn.className} ${buttonStatus}`} onClick={this.deleteCurrentViewerHandler.bind(this)}>{this.state.viewerDeleteBtn.title}</button>
              <button type="button" className={`btn btn-primary btn-single-line ${buttonStatus}`} onClick={this.createNewViewerHandler.bind(this)}>Create new Viewer</button>
              <button disabled={!this.state.selectedViewer} type="button" className={`btn btn-primary btn-single-line ${buttonStatus}`} onClick={() => this.copyStore(this.state.selectedViewer, this.props.viewerGUID, "Viewer")}>Copy Viewer</button>
              <button
                type="button"
                disabled={(this.props.existingViewers?.length ?? 0) < 2}
                className={`btn btn-primary btn-single-line ${buttonStatus}`}
                onClick={() => this.props.setModal(true, "Clone Combined Viewer", <div id="divCombinedViewer">
                  {this.props.existingViewers.map((e) => <p key={e.guid}>
                    <label style={{ width: 20 }}></label>
                    <input id={`chk_${e.guid}`} type="checkbox" value={e.guid} style={{ marginRight: 10, cursor: "pointer" }} onClick={(cb) => {
                      if (cb.target.checked) cb.target.setAttribute("data-time", new Date().getTime());
                      else cb.target.removeAttribute("data-time");
                      const checked = Array.from(document.querySelectorAll("#divCombinedViewer input[type=checkbox]:checked"));
                      checked.sort((a, b) => parseInt(a.getAttribute("data-time")) - parseInt(b.getAttribute("data-time")));
                      Array.from(document.querySelectorAll("#divCombinedViewer input[type=checkbox]")).forEach((e) => e.previousElementSibling.innerHTML = "");
                      for (let i = 0; i < checked.length; i++) checked[i].previousElementSibling.innerHTML = i + 1;
                    }} />
                    <label htmlFor={`chk_${e.guid}`} style={{ cursor: "pointer" }}>{e.name}</label>
                  </p>)}
                </div>, () => {
                  const checked = Array.from(document.querySelectorAll("#divCombinedViewer input[type=checkbox]:checked"));
                  if (checked.length < 2) {
                    alert("Please select at least 2 viewers");
                    return;
                  }
                  checked.sort((a, b) => parseInt(a.getAttribute("data-time")) - parseInt(b.getAttribute("data-time")));
                  this.cloneCombinedStore(checked.map((e) => e.value.toString()).join(","), this.props.viewerGUID, "Viewer");
                  this.props.setModal();
                })}
              >
                Clone Combined Viewer
              </button>
            </li>
            <li className="list-group-item card-header">
              <h6 className="card-subtitle mb-2 text-muted">Quizzes</h6>
              <Select
                value = {this.state.selectedQuiz}
                existingViewers = {this.props.existingQuizzes}
                onChange={this.handleQuizSelectChange.bind(this)}
                className="current-quizzes"
              />
              <button disabled={!this.state.selectedQuiz} type="button" className={`btn btn-primary quiz ${buttonStatus}`} onClick={this.editCurrentQuizHandler.bind(this)}>Edit Quiz</button>
              <button disabled={!this.state.selectedQuiz} type="button" className={`btn btn-primary quiz ${this.state.quizDeleteBtn.className} ${buttonStatus}`} onClick={this.deleteCurrentQuizHandler.bind(this)}>{this.state.quizDeleteBtn.title}</button>
              <button type="button" className={`btn btn-primary btn-single-line ${buttonStatus}`} onClick={this.createNewQuizHandler.bind(this)}>Create new Quiz</button>
              <button disabled={!this.state.selectedQuiz} type="button" className={`btn btn-primary btn-single-line ${buttonStatus}`} onClick={() => this.copyStore(this.state.selectedQuiz, this.props.quizGUID, "Quiz")}>Copy Quiz</button>
              <button
                type="button"
                disabled={(this.props.existingQuizzes?.length ?? 0) < 2}
                className={`btn btn-primary btn-single-line ${buttonStatus}`}
                onClick={() => this.props.setModal(true, "Clone Combined Quiz", <div id="divCombinedQuiz">
                  {this.props.existingQuizzes.map((e) => <p key={e.guid}>
                    <label style={{ width: 20 }}></label>
                    <input id={`chk_${e.guid}`} type="checkbox" value={e.guid} style={{ marginRight: 10, cursor: "pointer" }} onClick={(cb) => {
                      if (cb.target.checked) cb.target.setAttribute("data-time", new Date().getTime());
                      else cb.target.removeAttribute("data-time");
                      const checked = Array.from(document.querySelectorAll("#divCombinedQuiz input[type=checkbox]:checked"));
                      checked.sort((a, b) => parseInt(a.getAttribute("data-time")) - parseInt(b.getAttribute("data-time")));
                      Array.from(document.querySelectorAll("#divCombinedQuiz input[type=checkbox]")).forEach((e) => e.previousElementSibling.innerHTML = "");
                      for (let i = 0; i < checked.length; i++) checked[i].previousElementSibling.innerHTML = i + 1;
                    }} />
                    <label htmlFor={`chk_${e.guid}`} style={{ cursor: "pointer" }}>{e.name}</label>
                  </p>)}
                </div>, () => {
                  const checked = Array.from(document.querySelectorAll("#divCombinedQuiz input[type=checkbox]:checked"));
                  if (checked.length < 2) {
                    alert("Please select at least 2 quizzes");
                    return;
                  }
                  checked.sort((a, b) => parseInt(a.getAttribute("data-time")) - parseInt(b.getAttribute("data-time")));
                  this.cloneCombinedStore(checked.map((e) => e.value.toString()).join(","), this.props.quizGUID, "Quiz");
                  this.props.setModal();
                })}
              >
                Clone Combined Quiz
              </button>
            </li>
            <li className="list-group-item">
              <div className="btn"></div>
              <button type="button" className={`btn btn-primary ${buttonStatus}`} onClick={this.onLogout.bind(this)}>Logout</button>
            </li>
          </ul>
        </form>
      </div>
    </div>
  )
}
}

// -----------------------------------------------------------------------------
// React/Redux Stuff
// -----------------------------------------------------------------------------

function mapStateToProps(state) {
  return {
    existingViewers: state.editor.existingViewers,
    existingQuizzes: state.editor.existingQuizzes
  }
}

// Anything returned from this fuction will end up as props
function mapDispatchToProps(dispatch) {

  return bindActionCreators({
    setModal,
    di1EditorGetViewerList,
    di1EditorGetQuizList
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectEditor))
